import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import StockDividendCalenderListDisplay from './StockDividendCalenderListDisplay';

class StockDividendCalenderWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Stock Dividend Calender</title>
          <link rel="canonical" href="https://www.vizfm.com/stockDividend" />
          <meta name="description" content="Stock Dividend Calender for Investors and Traders" />
        </Helmet>
        <Container fluid className="p-2">
          <Row><Col>Stock Dividend Calender</Col></Row>
          <Row>
            <Col><StockDividendCalenderListDisplay limt={100}/></Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default StockDividendCalenderWrap;
